import { render, staticRenderFns } from "./CallLogs.vue?vue&type=template&id=22bf2b78&scoped=true"
import script from "./CallLogs.vue?vue&type=script&lang=js"
export * from "./CallLogs.vue?vue&type=script&lang=js"
import style0 from "./CallLogs.vue?vue&type=style&index=0&id=22bf2b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf2b78",
  null
  
)

export default component.exports